module.exports = __webpack_public_path__ + "static/media/Phenikaa_Manufacturing.2eccf8b0.jpg";